import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function statusBadgeClass(status) {
  const s = (status || "").toLowerCase().trim();
  if (s === "all done" || s === "confirm" || s === "all paid" || s === "delivery done,payment pendding") return "badge badge-green";
  if (s.includes("delivery done")) return "badge badge-blue";
  if (s === "cancel" || s === "shoot not happen" || s.includes("not happen") || s.includes("overdue")) return "badge badge-red";
  if (s.includes("pending") || s.includes("pendding") || s === "waiting" || s === "working" || s === "correction" || s === "coreection" || s.includes("work done") || s.includes("reel")) return "badge badge-yellow";
  return "badge badge-stone";
}

export function inr(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

/**
 * Parse a date string into a JS Date in LOCAL time.
 * For ISO date-only strings ("YYYY-MM-DD"), we intentionally avoid `new Date(s)`
 * because that parses as UTC midnight, which then shifts +1 day in IST/+timezones
 * and −1 day in negative-offset timezones when displayed.
 */
export function parseLocalDate(value) {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const s = String(value).trim();
  if (!s) return null;
  const isoDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (isoDateOnly) {
    const [, y, m, d] = isoDateOnly;
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  const isoWithTime = /^(\d{4})-(\d{2})-(\d{2})T/.exec(s);
  if (isoWithTime) {
    const [, y, m, d] = isoWithTime;
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

/**
 * Format a Date (or date-string) as a YYYY-MM-DD string in LOCAL time.
 * Use this for consistent keying — never `.toISOString().slice(0,10)`,
 * which silently shifts by ±1 day across timezones.
 */
export function localIsoDate(value) {
  const dt = value instanceof Date ? value : parseLocalDate(value);
  if (!dt) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  const dt = parseLocalDate(d);
  if (!dt) return typeof d === "string" ? d : "—";
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function waLink(phone, message) {
  const clean = (phone || "").replace(/[^\d]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(message || "")}`;
}
